import type { AppDispatch } from '@/store'
import { clearDomain } from '@/store/features/domain/domainSlice'
import { clearJoinRequests } from '@/store/features/joinRequest/joinRequestSlice'
import { clearMembers } from '@/store/features/member/memberSlice'
import { clearUsageData } from '@/store/features/usage/usageSlice'
import { clearEnterpriseData, clearUser } from '@/store/features/user/userSlice'
import { invalidateTenantRequests } from '@/store/tenantRequestFence'

/**
 * Clears every tenant-scoped slice on a tenant or session transition.
 *
 * Slices gate their fetch on `hasLoaded`, so a slice left uncleared makes the next
 * mount skip its fetch and render the previous tenant's rows.
 */
export const resetTenantState = (dispatch: AppDispatch, scope: 'enterprise' | 'session') => {
  dispatch(invalidateTenantRequests())
  // 'session' drops the signed-in user too; 'enterprise' keeps them (still logged in).
  dispatch(scope === 'session' ? clearUser() : clearEnterpriseData())
  dispatch(clearUsageData())
  dispatch(clearMembers())
  dispatch(clearDomain())
  dispatch(clearJoinRequests())
}
